import _classCallCheck from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/createClass.js";
export var LogLevel = {
  Verbose: 5,
  Log: 4,
  Warnings: 3,
  Errors: 2,
  Silent: 0
};

function IsCustomLevel(l) {
  return typeof l === 'object';
}

var Logger = /*#__PURE__*/function () {
  function Logger() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : LogLevel.Silent;

    _classCallCheck(this, Logger);

    this.options = options === true ? {
      level: LogLevel.Verbose
    } : typeof options === "number" ? {
      level: options
    } : options;
  }

  _createClass(Logger, [{
    key: "log",
    value: function log() {
      if (IsCustomLevel(this.options.level) ? this.options.level.log : this.options.level >= LogLevel.Log) {
        var _console;

        (_console = console).log.apply(_console, arguments);
      }
    }
  }, {
    key: "warn",
    value: function warn() {
      if (IsCustomLevel(this.options.level) ? this.options.level.warn : this.options.level >= LogLevel.Warnings) {
        var _console2;

        (_console2 = console).warn.apply(_console2, arguments);
      }
    }
  }, {
    key: "error",
    value: function error() {
      if (IsCustomLevel(this.options.level) ? this.options.level.error : this.options.level >= LogLevel.Errors) {
        var _console3;

        (_console3 = console).error.apply(_console3, arguments);
      }
    }
  }]);

  return Logger;
}();

export { Logger as default };